import { ColDef } from 'ag-grid-enterprise';
import { OptionCell } from './OptionCell';
import { format } from 'date-fns';
import { formatCurrency } from '~/lib/money';

export type FundValuationEvent = {
  id: string;
  valuationDate: Date | string;
  valueLocal: number;
  currency: string;
  handleRemove: (fundValuationId: string) => void;
  options?: string;
};

export const colDefsFundValuationEventTable: ColDef<FundValuationEvent>[] = [
  {
    field: 'valuationDate',
    headerName: 'Date',
    sortable: true,
    filter: true,
    type: 'w200',
    autoHeight: true,
    cellClass: 'flex align-items-center justify-content-left',
    wrapText: true,
    valueFormatter: (p) => (p.value ? format(p.value, 'yyyy-MM-dd') : '-'),
  },
  {
    field: 'valueLocal',
    headerName: 'Dry Powder',
    sortable: true,
    cellClass: 'flex align-items-center justify-content-left',
    type: 'w200',
    filter: true,
    valueFormatter: (p) =>
      typeof p.value === 'number'
        ? formatCurrency(p.data?.currency ?? 'EUR', p.value)
        : '-',
  },
  {
    field: 'options',
    headerName: '',
    cellRenderer: OptionCell,
    cellClass: 'flex align-items-center justify-content-center',
    type: 'w120',
    sortable: true,
    filter: true,
  },
];
